import { useDispatch } from "react-redux";
import { createPortal } from "react-dom";
import { LogOut } from "lucide-react";
import Button from "../../../_components/ui/Button";
import { signOut } from "../../../_features/auth/state/authSlice";
import "./LogoutModal.scss";

const LogoutModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const handleConfirmLogout = () => {
    dispatch(signOut());
    onClose();
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="logout-modal" onClick={onClose}>
      <div
        className="logout-modal__content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="logout-modal__header">
          <div className="logout-modal__title">
            <LogOut size={24} className="logout-modal__icon" />
            <h2>Logout?</h2>
          </div>
          <p>Are you sure you want to logout?</p>
        </div>
        <div className="logout-modal__actions">
          <Button
            variant="contained"
            className="logout-modal__btn logout-modal__btn--primary"
            onClick={handleConfirmLogout}
          >
            Yes, Logout
          </Button>
          <Button
            variant="outlined"
            className="logout-modal__btn logout-modal__btn--secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutModal;
